/**
* Copyright by:

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faChevronDoubleRight,
  faArrowDownLeftAndArrowUpRightToCenter,
  faUndo
} from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-filter-panel',
  imports: [CommonModule, FormsModule, MatButtonModule, FontAwesomeModule],
  templateUrl: './filter-panel.component.html',
  styleUrl: './filter-panel.component.scss'
})
export class FilterPanelComponent {
  @Input() title: string = 'Filter';
  @Input() isOpen: boolean = true;
  @Input() resetDisabled: boolean = false;
  @Output() filterReset = new EventEmitter<void>();
  @Output() isOpenChange = new EventEmitter<boolean>();

  readonly faArrowDownLeftAndArrowUpRightToCenter = faArrowDownLeftAndArrowUpRightToCenter;
  readonly faChevronDoubleRight = faChevronDoubleRight;
  readonly faUndo = faUndo;

  togglePanel(): void {
    this.isOpen = !this.isOpen;
    this.isOpenChange.emit(this.isOpen);
  }

  onReset(): void {
    this.filterReset.emit();
  }
}
